<template>
  <info-header-card
    :icon="customer.icon()"
    :header="header"
    :rows="rows"
  />
</template>

<script>
import CustomerModel from "@/models/crm/CustomerModel"
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "CustomerCard",
  components: {
    InfoHeaderCard
  },
  props: {
    customer: {
      type: Object,
      default: () => new CustomerModel()
    }
  },
  computed: {
    account_number() {
      return this.customer.account_number;
    },
    short_name() {
      return this.customer.short_name
    },
    header() {
      return `#${this.account_number} | ${this.short_name}`
    },
    rows() {
      return [
        {
          label: 'Short Name',
          value: this.short_name
        },
        {
          label: 'Account #',
          value: this.account_number
        }
      ]
    }
  }
}
</script>
